export default {"src":"/_next/static/media/peep-dark.d6cc0547.svg","height":1500,"width":1500};